import { AdPlacement } from "@/components/ads/AdPlacement";
import type { HealthCalcDef } from "../calculators";
import { BmiBreadcrumb } from "../components/BmiBreadcrumb";
import { BmiExplainer } from "../components/BmiExplainer";
import { BmiRelated } from "../components/BmiRelated";

export function CalculatorPage({ def }: { def: HealthCalcDef }) {
  const Component = def.Component;
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <BmiBreadcrumb current={def.navName()} />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {def.h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {def.intro()}
          </p>
        </header>

        <Component />

        <BmiRelated currentSlug={def.slug} />

        <BmiExplainer
          howTo={def.howTo()}
          faqs={def.faqs.map((f) => ({ q: f.q(), a: f.a() }))}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
